import { render, staticRenderFns } from "./LeaveTypePropertyGroup.vue?vue&type=template&id=0ae46289&"
import script from "./LeaveTypePropertyGroup.vue?vue&type=script&lang=js&"
export * from "./LeaveTypePropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae46289')) {
      api.createRecord('0ae46289', component.options)
    } else {
      api.reload('0ae46289', component.options)
    }
    module.hot.accept("./LeaveTypePropertyGroup.vue?vue&type=template&id=0ae46289&", function () {
      api.rerender('0ae46289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveTypePropertyGroup/LeaveTypePropertyGroup.vue"
export default component.exports